export default __webpack_public_path__ + "static/media/Product-Id.c272a83f.jpg";